module.exports = __webpack_public_path__ + "assets/chevron-down.b28f2866.svg";